import { NgModule } from '@angular/core';
import { ErrorPagesModule } from './error';

@NgModule({
  imports: [ErrorPagesModule],
  exports: [ErrorPagesModule],
})
export class PagesModule {}
